<template>
    <div class="studyBox">
        <div class="study-box">
            <div class="study-content">
                <div class="study-content-tab" >
                    <div class="tab-box">
                        <div id="slide-swapper" :class="{isFilter:!isFilter}">
                            <span :class="tabid === item.id ? 'activespan' : ''" @click="tabid=item.id" v-for="(item, index) in tabList" :key="index">{{item.value}}</span>
                        </div>
                    </div>
                    <div class="study-select"  @click.stop="stateisShow" v-if="isFilter">
                        <p class="line"></p>
                        <svg-icon icon-class="screening-icon" class-name="screening-icon"></svg-icon>
                        <span>
                            {{selectTxt}}
                        </span>
                        <div class="options" v-if="show && isFilter">
                            <div
                                @click="select(item)"
                                :title="item.lable"
                                :class=" showValue === item.value ? 'option active':'option'"
                                v-for="item in list"
                                :value="item.value"
                                :key="item.value"
                            >{{item.label}}</div>
                        </div>
                    </div>
                </div>
                <div v-show="tabid === 1">
                    <trainlist :learnValidity="learnValidity" ref="trainlist1"></trainlist>
                </div>
                <div v-show="tabid === 2">
                    <camplist :learnValidity="learnValidity" ref="camplist1"></camplist>
                </div>
                <div v-show="tabid === 3">
                    <evaluationlist :learnValidity="learnValidity" ref="evaluationlist1"></evaluationlist>
                </div>
                <div v-show="tabid === 4">
                    <examlist :learnValidity="learnValidity" ref="examlist1"></examlist>
                </div>
                <div v-show="tabid === 5">
                    <livelist :learnValidity="learnValidity" ref="livelist1"></livelist>
                </div>
                <div v-show="tabid === 6">
                    <testlist :learnValidity="learnValidity" ref="testlist1"></testlist>
                </div>

            </div>
            <div v-if="show && isFilter" class="training-select-bg"></div>
        </div>
    </div>
</template>
<script>
import examlist from "./examlist.vue";
import trainlist from "./taskList.vue";
import camplist from "./camplist.vue";
import evaluationlist from "./evaluationlist.vue";
import livelist from './liveList.vue';
import testlist from './testlist.vue';
export default {
    name: "learningIndex",
    components: {
        examlist,
        trainlist,
        camplist,
        evaluationlist,
        livelist,
        testlist
    },
    data() {
        return {
            isFilter:true,
            backHomepage:null,//返回首页路由
            learnValidity:false,
            tabList: [],
            tabList2: [
                {"id":1,"key":"trainingTask","value":"培训任务"},
                {"id":2,"key":"trainingCamp","value":"训练营"},
                {"id":3,"key":"evaluation","value":"测评"},
                {"id":4,"key":"exam","value":"考试"},
                {"id":5,"key":"live","value":"直播"},
                {"id":6,"key":"test","value":"练习"}
            ],
            tabValue:null,
            tabid: null,
            active: 1,
            showValue: "",
            show: false,
            selectTxt: "筛 选",
            trainingList: [],

            loadMoreStatus: "more",
            list:[],
            list1: [
                {
                    value: "",
                    label: "全部"
                },
                {
                    value: "1",
                    label: "未开始"
                },
                {
                    value: "2",
                    label: "进行中"
                },
                {
                    value: "3",
                    label: "已结束"
                }
            ],
            list2: [
                {
                    value: "",
                    label: "全部"
                },
                {
                    value: "0",
                    label: "进行中"
                },
                {
                    value: "1",
                    label: "已过期"
                }
            ],
            // list3: [
            //     {
            //         value: "",
            //         label: "全部"
            //     },
            // ],

            // redirectPage:['gongxin_homepage','wanghong_homepage','housekeeping_homepage','junmin_homepage','yingji_homepage','jz_homepage'], // 浏览器自带返回 定制机构返回自己首页
        };
    },
    watch:{
         tabid: {
            handler(n) {
                this.showValue = '';
                this.selectTxt = '筛选';
                if(n===1){
                    this.isFilter = true;
                    this.list=this.list1;
                    this.$refs.trainlist1.selectcheck(this.showValue);
                }else if(n===2){
                    this.isFilter = true;
                    this.list=this.list1;
                    this.$refs.camplist1.selectcheck(this.showValue);
                }else if(n===3){
                    this.isFilter = true;
                    this.list=this.list2;
                    this.$refs.evaluationlist1.selectcheck(this.showValue);
                }
                else if(n===4){
                    this.isFilter = false;
                    // this.list=this.list3;
                    this.$refs.examlist1.selectcheck(this.showValue);
                }else if(n === 5){
                    this.isFilter = false;
                    // this.list = this.list3;
                    this.$refs.livelist1.selectcheck(this.showValue)
                }else if(n === 6){
                    this.isFilter = false;
                    // this.list = this.list3;
                    this.$refs.testlist1.selectcheck(this.showValue)
                }
            },
            immediate: true
        },
    },
    created(){
        // console.log(sessionStorage.getItem('frontendConfig'),'frontendConfig========')
        const frontendConfigArr = (sessionStorage.getItem('frontendConfig') && JSON.parse(sessionStorage.getItem('frontendConfig'))) || this.$store.state.dynamic.frontendConfig || [];
        const learningTab = frontendConfigArr.length && frontendConfigArr.filter(item => {
            if(item.key === 'task_tag_array_learn_center'){
                return true
            }
        })[0];
        

        if(learningTab && JSON.parse(learningTab.value) && JSON.parse(learningTab.value).length>0){
            this.tabList = (learningTab && JSON.parse(learningTab.value)) || this.tabList2;
        } else {
            this.tabList = this.tabList2;
        }
        if(this.$route.query.backType){
            this.tabid=Number(this.$route.query.backType);
        }else{
            this.tabid=this.tabList[0].id;
        }
        frontendConfigArr.length && frontendConfigArr.filter(item => {
            if(item.key === 'is_show_task_term_validity'){
                this.learnValidity=JSON.parse(item.value);
            }
        })[0];
        //模拟考试跳转默认选中考试
        if(this.$route.query.isExam){
            this.tabid = 4
        }
    },
    filters: {
        formateTime: function(val) {
            return val ? (val / 3600).toFixed(2) : val;
        },
        formateData: function(val) {
            return val.split(" ")[0];
        }
    },
    mounted() {
        if(sessionStorage.getItem('homepage')){
            this.backHomepage = JSON.parse(sessionStorage.getItem('homepage'))[0].value
        }else if(this.$store.state.homepage){
            this.backHomepage =  this.$store.state.homepage && this.$store.state.homepage[0].value
        }
        console.log(this.backHomepage,'backHomepage')

        if (window.history && window.history.pushState) {
            // 往历史记录里面添加一条新的当前页面的url
            history.pushState(null, null, document.URL);
            // 给 popstate 绑定一个方法 监听页面刷新
            window.addEventListener("popstate", this.backChange2, false); //false阻止默认事件
        }
        window.addEventListener("click", () => {
            this.show = false;
        });
    },
    beforeDestory() {
        localStorage.removeItem('showPageOfyuan')
    },
    destroyed() {
        window.removeEventListener("popstate", this.backChange2, false); //false阻止默认事件
    },
    methods: {
        backChange2() {
            // 如果是定制页返回定制页的首页 则返回大平台
            console.log(this.backHomepage,'backHomepage=====')
            this.$router.replace(this.backHomepage || 'home')

            const pathArr = window.location.href.split('?')
            if(pathArr.length>1) {
                if(this.$route.query.goodsId2) {
                    let url = `${this.$route.query.name}&distributionId=${this.$route.query.distributionId}&goodsId=${this.$route.query.goodsId}`
                    this.$router.replace({
                        path: url
                    })
                } else if(this.$route.query.goodsId) {
                    let url = `${this.$route.query.name}&distributionId=${this.$route.query.distributionId}&goodsId=${this.$route.query.goodsId}&goodsId2=${this.$route.query.goodsId2}&goodsId3=${this.$route.query.goodsId3}`

                    this.$router.replace({
                        path: url
                    })
                }

            }


        },


        stateisShow() {
            this.show = !this.show;
        },
        select(e) {
            this.showValue = e.value;
            this.selectTxt = e.label;
            if(this.tabid===1){
                this.$refs.trainlist1.selectcheck(e.value);
            }else if(this.tabid===2){
                this.$refs.camplist1.selectcheck(e.value);
            }else if(this.tabid===3){
                this.$refs.evaluationlist1.selectcheck(e.value);
            }
        }
    }
};
</script>
<style lang="less" scoped>
.studyBox{
    min-height: 100vh;
    background: #F9F9F9;
}
.study-box {
    position: relative;
    .study-content {
        width: 100%;
        position: absolute;
        top: 0px; //375px;
        bottom: -2px;
        .study-content-tab{
            background: #FFFFFF;
            padding:0 30px;
            border-bottom: .053333rem solid #EAEAEA ;
            display: flex;

            .tab-box {
                overflow: hidden;
                #slide-swapper {
                    width: calc(100vw - 220px);
                    padding-top: 26px;
                    white-space: nowrap;
                    display: -webkit-box;
                    box-sizing: border-box;
                    overflow-x: scroll;
                    overflow-y: hidden;
                    // 使滑动流畅
                    -webkit-overflow-scrolling: touch;
                    -ms-overflow-style: none;
                    overflow: -moz-scrollbars-none;
                    // 滚动条撑开 隐藏滚动条
                    padding-bottom: 44px;
                    margin-bottom: -20px;
                    &.isFilter{
                        width: 100% ;
                    }
                    span{
                        font-size: 30px;
                        position: relative;
                        font-weight: 500;
                        color: #999999;
                        margin-right: 50px;
                        display: inline-block;
                    }
                    .activespan{
                        color: #333333;
                        font-size: 34px;
                        &::after{
                            content: '';
                            position: absolute;
                            top: 48px;
                            left: 50%;
                            margin-left: -23px;
                            width: 46px;
                            height: 6px;
                            background: #405FF6;
                            border-radius: 3px;
                        }
                    }
                }
            }


            .study-select {
                .line{
                    width: 12px;
                    height: 100%;
                    // margin-right: 20px;
                    display: inline-block;
                    vertical-align: middle;
                    margin-left: 20px;
                }
                .screening-icon{
                    font-size: 26px;
                    margin-right: 6px;
                    vertical-align: middle;
                }
                span {
                    font-size: 30px;
                    font-weight: 400;
                    color: #333333;
                    display: inline-block;
                    vertical-align: middle;
                }
                .options:before {
                    display: block;
                    content: "";
                    border-width: 16px 16px 16px 16px;
                    border-style: solid;
                    border-color: transparent transparent #fff transparent;
                    position: absolute;
                    left: 90px;
                    top: -30px;
                    transform: rotate(0deg); //旋转度数
                }
                .options {
                    position: absolute;
                    background: #ffffff;
                    border-radius: 5px !important;
                    width: 160px;
                    right: 0;

                    // margin-top: 32px;
                    z-index: 99;
                    border-radius: 5px;
                    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
                    .option {
                        font-size: 28px;
                        box-sizing: border-box;
                        white-space: nowrap;
                        width: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        text-align: left;
                        height: 100px;
                        line-height: 100px;
                        text-align: center;
                        color: #666666;
                    }
                    .option:nth-child(1) {
                        border-top-left-radius: 5px;
                        border-top-right-radius: 5px;
                    }
                    .active {
                        color: #415FF6 !important;
                        font-weight: bold;
                        background:#EFF1FE !important;
                    }
                    .arrow {
                        display: block;
                        border-bottom: 10px solid #ccc;
                        border-right: 10px solid #fff;
                        border-left: 10px solid #fff;
                        border-top: 10px solid #fff;
                        width: 30px;
                        height: 30px;
                        position: relative;
                        top: -40px;
                        left: 100px;
                    }
                }
            }
        }

    }
    .training-select-bg {
        position: fixed;
        top: 0;
        bottom: 0;
        height: 100%;
        width: 100%;
        background: rgba(0, 0, 0, 0.12);
    }
    // .study-box .van-tabs {
    //     z-index:98;
    // }
    /deep/.van-tabs__wrap {
        height: 55px;
        background: #ffffff;
        border-radius: 12px 12px 0px 0px;
    }
    // /deep/.van-tabs__line{
    //     width: 30px;
    //     height: 3px;
    //     background: #3760FF;
    //     border-radius: 3px;
    // }
}
</style>

